import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import {
  AuthModule,
  GetMsalInterceptorConfiguration,
  LoginCallbackComponent,
  getB2CMsalGuardConfig,
  getB2CMsalInstance,
  getB2CMsalInterceptorConfig,
} from '@vinnova/auth';
import {
  chatbotApiUrl as CHATBOT_API_URL,
  ChatbotWidgetComponent,
} from '@vinnova/chatbot';
import { ApimInterceptor, ETjansterModule } from '@vinnova/e-tjanster';
import { TranslationModule } from '@vinnova/translation';
import * as i18nIsoCountries from 'i18n-iso-countries';
import * as en from 'i18n-iso-countries/langs/en.json';
import * as sv from 'i18n-iso-countries/langs/sv.json';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const interceptorConfig = getB2CMsalInterceptorConfig(
    environment.b2cMsalConfig,
    undefined,
    [
      {
        url: `${environment.etjansterCommonApiUrl}/account/loginb2c`,
        clientId: environment.b2cMsalConfig.clientId.etjansterCommonApiClientId,
      },
      {
        url: `${environment.etjansterCommonApiUrl}/betalningsuppgifter`,
        clientId: environment.b2cMsalConfig.clientId.etjansterCommonApiClientId,
      },
    ],
    [environment.resourceStringUrl],
  );
  return GetMsalInterceptorConfiguration(
    interceptorConfig,
    environment.b2cMsalConfig,
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18nIsoCountries.registerLocale((sv as any).default);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18nIsoCountries.registerLocale((en as any).default);

@NgModule({
  declarations: [AppComponent, LayoutComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ETjansterModule.forRoot(environment),
    AuthModule.forRoot(environment, 'bedomning'),
    TranslationModule.forRoot(environment),
    MsalModule.forRoot(
      getB2CMsalInstance(environment.b2cMsalConfig),
      getB2CMsalGuardConfig(),
      undefined,
    ),
    LoginCallbackComponent,
    ChatbotWidgetComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApimInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: CHATBOT_API_URL,
      useValue: environment.chatbotApiUrl,
    },
  ],
})
export class AppModule {}
